import script from "./SpaceInsertCom.vue?vue&type=script&setup=true&lang=js"
export * from "./SpaceInsertCom.vue?vue&type=script&setup=true&lang=js"

import "./SpaceInsertCom.vue?vue&type=style&index=0&id=a1b0e554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1b0e554"]])

export default __exports__